import type { AnyFieldApi } from '@tanstack/react-form';
import { Button } from '@ui/themed';
import { t } from 'i18next';

export function ResetSettingsButton({ field }: { field: AnyFieldApi }) {
  return (
    <Button variant="secondary" onClick={() => field.handleChange(undefined)}>
      {t('buttons:reset')}
    </Button>
  );
}
